import createContextProxy from 'src/state/context/contextProxy'
import type { SignOutType } from './LogOut'

const signOutStateProvider = createContextProxy<SignOutType>('Content')

export const SignOutContext = signOutStateProvider.ContextProxy
export const SignOutStateProvider = signOutStateProvider.ContextProxyProvider
export const useLogOut = signOutStateProvider.useProxy
